import { TRAIN as Fetch } from '@/api'

// 请求首页课程
export const postHomeCourse = (data) =>
  Fetch({
    url: '/teacher-train-service/train/course/center/class/course/view',
    method: 'post',
    data
  })

// 请求首页banner
export const postBanner = (data) =>
  Fetch({
    url: '/teacher-train-service/train/activity/list',
    method: 'post',
    data
  })
